var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { PlaceService } from '../../../../services/place.service';
var VisitorLongCardComponent = /** @class */ (function (_super) {
    __extends(VisitorLongCardComponent, _super);
    function VisitorLongCardComponent(router, imageService, modalService, editorChoiceStore, customizationApiService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.editorChoiceStore = editorChoiceStore;
        _this.customizationApiService = customizationApiService;
        _this.activatedRoute = activatedRoute;
        _this.preventClick = false;
        _this.eventTimeText = '';
        _this.placeCategory = '';
        _this.editorChoiceText = '';
        return _this;
    }
    VisitorLongCardComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        if (this.item.startTime) {
            this.eventTimeText = this.isMobile
                ? this.item.startTimeFormatted
                : "" + this.item.startTimeFormatted + (this.item.endTimeFormatted ? ' - ' + this.item.endTimeFormatted : '');
        }
        else {
            if (this.item['categoryList']) {
                this.placeCategory = '';
                var cate = '';
                for (var _i = 0, _a = this.item['categoryList']; _i < _a.length; _i++) {
                    var category = _a[_i];
                    cate += PlaceService.toReadableCategory(category) + ', ';
                    if (cate.length < 44) {
                        this.placeCategory = cate;
                    }
                }
                // remove the last comma
                this.placeCategory = this.placeCategory.substr(0, this.placeCategory.length - 2);
            }
        }
        this.editorChoiceTextHandler();
    };
    VisitorLongCardComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe(function (editorChoice) {
            if (!!_this.item.startTime) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorLongCardComponent.prototype.enterItemByKeyboard = function ($event) {
        if ($event && $event.key === 'Enter') {
            this.showDetails();
        }
    };
    VisitorLongCardComponent.prototype.showDetails = function () {
        if (this.preventClick) {
            return;
        }
        if (this.item.isPromotionImage) {
            this.item.promotionLink = this.item.promotionLink.startsWith('http')
                ? this.item.promotionLink
                : 'http://' + this.item.promotionLink;
            window.open(this.item.promotionLink, '_blank');
            return;
        }
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, menuType = _a.menuType;
        if (this.item.startTime) {
            // this is an event
            if (!this.isMobile) {
                this.item.hubName = this.hubName;
                var actions = {
                    confirm: function (event, data) {
                    },
                };
                this.modalService.show({
                    component: EventDetailsModalComponent,
                    providers: [
                        { provide: EventDetailsModalActions, useValue: actions },
                        { provide: HubEvent, useValue: this.item },
                    ],
                    panelClass: 'modal-fixed-top-lower',
                });
            }
            else {
                this.showDetailModalForMobile(this.item, 'event');
                // this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventDetails,
                //     {
                //         hubName,
                //         eventId: this.item._id
                //     }), {skipLocationChange: this.noChangeUrlWhenRedirect});
            }
        }
        else {
            // this is a place
            if (!this.isMobile) {
                var actions = {
                    confirm: function (event, data) {
                    },
                };
                this.modalService.show({
                    component: PlaceDetailsModalComponent,
                    providers: [
                        { provide: PlaceDetailsModalActions, useValue: actions },
                        { provide: HubPlace, useValue: this.item },
                    ],
                    panelClass: 'modal-fixed-top',
                });
            }
            else {
                this.showDetailModalForMobile(this.item, 'place');
                // category = PlaceCategory.getPlaceCategoryKey(category);
                // this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails,
                //     {
                //         hubName,
                //         placeId: this.item._id,
                //         category: category,
                //         menuType: menuType
                //     }), {skipLocationChange: this.noChangeUrlWhenRedirect});
            }
        }
    };
    VisitorLongCardComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorLongCardComponent.prototype.remove = function () {
    };
    return VisitorLongCardComponent;
}(BaseComponent));
export { VisitorLongCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/long.card/visitor.long.card.component.ts.pre-build-optimizer.js